import React from 'react';
import { Provider } from 'react-redux';
import Hidden from '@material-ui/core/Hidden';
import ReactOnRails from 'react-on-rails';
// import LeftSidenav from '../components/Public/LeftSidenav/LeftSidenav';
// import appDuck from 'appDir/redux/modules/appDuck';
import apolloClient from 'appDir/lib/apollo/client';
import { ApolloProvider } from '@apollo/client';
// import useSetApolloCache from 'appDir/routes/useSetApolloCache';
import SidenavUIJ from 'appDir/layout/SidenavUIJ';
import { CloudinaryContext } from 'cloudinary-react';

// const LeftSidenavWrapped = ({ railsContext }) => {
//   const canEditOrganization = useSelector(
//     appDuck.selectors.canEditOrganization
//   );
//   const cacheLoaded = useSetApolloCache(railsContext);

//   if (!canEditOrganization) return null;
//   if (!cacheLoaded) return null;
//   return <LeftSidenav showOrganizerAppBar />;
// };

const LeftSidenavApp = (_props, railsContext) => {
  const { store } = ReactOnRails.getStore('appStore');

  return (
    <ApolloProvider client={apolloClient}>
      <Provider store={store}>
        <CloudinaryContext cloudName={railsContext.cloudinaryCloudName}>
          <Hidden smDown>
            <SidenavUIJ />
          </Hidden>
        </CloudinaryContext>
      </Provider>
    </ApolloProvider>
  );
};

export default LeftSidenavApp;
